import React from "react";
import { Typography } from "@mui/material";
import colorsCustom from "../../designTokens/colorsCustom";
import PropTypes from "prop-types";

export const ThreadParagraph = ({ 
  children, 
  text,
  highlightText,
  isMobile = false,
  variant = "body1",
  sx = {},
  ...props 
}) => {
  const baseStyles = {
    lineHeight: 1.8,
    color: colorsCustom.ui.dark.bold,
    fontWeight: 500,
    width: isMobile ? "100%" : "calc(100% - 16px)",
    wordBreak: "keep-all",
    whiteSpace: "pre-wrap",
    ...sx
  };

  // URL을 링크로 변환하는 함수
  const processLinks = (inputText) => {
    // 느슨한 도메인 감지: http/https 없이도 example.com, foo.co.kr, bar.io/path 등 처리
    // 1) 프로토콜 또는 www. 로 시작하는 경우
    // 2) 또는 공백 경계에서 도메인 패턴을 포함하는 경우
    const urlPattern = /((?:https?:\/\/|www\.)[^\s<]+|\b[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s<]*)?)/gi;

    return inputText.replace(urlPattern, (raw) => {
      let url = raw;
      // 공백이나 HTML 태그 경계 외의 문자 제거
      url = url.replace(/[),.;!?]+$/, '');

      // 프로토콜 보강: 프로토콜이 없으면 https 추가
      const hasProtocol = /^https?:\/\//i.test(url);
      const href = hasProtocol ? url : `https://${url}`;

      return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color: #000; font-weight: bold; text-decoration: underline;">${raw}</a>`;
    });
  };

  // 텍스트 처리 함수
  const processText = (inputText) => {
    // 1. 개행을 <br/>로 변환
    let processed = inputText.replace(/\n/g, '<br/>');
    
    // 2. URL을 링크로 변환
    processed = processLinks(processed);
    
    return processed;
  };

  // 하이라이트 처리가 필요한 경우
  if (text && highlightText) {
    let processedText = processText(text);
    const highlightedText = processedText.replace(
      highlightText,
      `<span style="background-color: yellow;">${highlightText}</span>`
    );
    
    return (
      <Typography
        variant={isMobile ? "body1" : "body1"}
        sx={baseStyles}
        dangerouslySetInnerHTML={{ __html: highlightedText }}
        {...props}
      />
    );
  }

  // 일반 텍스트 처리 (개행 + 링크 포함)
  if (text) {
    const processedText = processText(text);
    
    return (
      <Typography
        variant={variant}
        sx={baseStyles}
        dangerouslySetInnerHTML={{ __html: processedText }}
        {...props}
      />
    );
  }

  // children 사용
  return (
    <Typography
      variant={variant}
      sx={baseStyles}
      {...props}
    >
      {children}
    </Typography>
  );
};

ThreadParagraph.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
  highlightText: PropTypes.string,
  isMobile: PropTypes.bool,
  variant: PropTypes.string,
  sx: PropTypes.object,
};